//@flow

import React from 'react';
import {makeStyles, CircularProgress} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

type Props = {
  className?: string,
  size?: number,
  loading?: boolean,
};

export default function InlineLoader(props: Props) {
  const {className, size = 24, loading} = props;

  const classes = useStyles();

  const loaderClasses = `${classes.root} ${className || ''}`;

  if (!loading) return null;

  return (
    <div className={loaderClasses}>
      <CircularProgress size={size} />
    </div>
  );
}
